import ECOMemberProfile from '@/views/integrations/ECOMember/Profile.vue'

export const ecoMemberProfileRoutes = {
  path: '/integrations/eco-member-profile/:partyId',
  name: 'integrationEcoMemberProfile',
  meta: { requiresAuth: false, title: 'ECO Member Profile - Innovation Law Lab Platform' },
  component: ECOMemberProfile,
  props: true,
}
